import { addHours } from "date-fns";

import { IShare } from "@formant/core/model/IShare";
import { Uuid } from "@formant/core/model/Uuid";

/**
 * The one-hour teleop link the teleop page's Share button hands out. The scope
 * names the robot: a share scope without device ids covers every robot in the
 * organization.
 */
export function teleopShareRequest(deviceId: Uuid, now: Date): IShare {
    const oneHourFromNow = addHours(now, 1);
    return {
        scope: {
            deviceIds: [deviceId],
            start: now.toISOString(),
            end: oneHourFromNow.toISOString(),
        },
        time: now.toISOString(),
        expiration: oneHourFromNow.toISOString(),
        message: "See my teleop view in action",
        delegateTeleop: true,
        userName: "",
    };
}
